import React from 'react'
import { faClone, faCog } from '@fortawesome/free-solid-svg-icons'
import { faCanadianMapleLeaf } from '@fortawesome/free-brands-svg-icons'
import { ThemeHeading } from '../../components/common/ThemeHeading'
import { ServiceBox } from './servicebox'

export default function Service(props) {
    return (
        <section className="service-wrapper site-margin wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.8s"
            id="service">
            <div className="container">
                <ThemeHeading heading="What I'm Doing" />
                <div className="row">
                    <ServiceBox Icon={faClone} Title="UX / UI Design" Content="It is a long established fact that a reader will be distracted by the when looking at its layout." />
                    <ServiceBox Icon={faCanadianMapleLeaf} Title="Graphic Designer" Content="It is a long established fact that a reader will be distracted by the when looking at its layout." />
                    <ServiceBox Icon={faCog} Title="Web Development" Content="It is a long established fact that a reader will be distracted by the when looking at its layout." />
                </div>
            </div>
         </section>
    )
}